import { useMutation } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import { RegisterDto, AuthResponseData } from '../services/api/auth.types';
import { parseApiErrorMessage } from '../services/api/api';

export function useRegister() {
  const { register } = useAuth();

  return useMutation<AuthResponseData, Error, RegisterDto>({
    mutationFn: async (dto: RegisterDto) => {
      try {
        return await register(dto);
      } catch (err) {
        const errorMsg = parseApiErrorMessage(err);
        throw new Error(errorMsg);
      }
    },
  });
}
